/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type MenuButtonSvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function MenuButtonSvgIcon(props: MenuButtonSvgIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 52 46"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <rect
        width={"51"}
        height={"45"}
        x={".5"}
        y={".5"}
        stroke={"#DEE2E6"}
        rx={"2.5"}
      ></rect>

      <path
        stroke={"#737373"}
        strokeWidth={"2"}
        d={"M15 15h22m-22 7h22m-22 7h22"}
      ></path>
    </svg>
  );
}

export default MenuButtonSvgIcon;
/* prettier-ignore-end */
